import { BeErrorsMap } from "./constants";

export const getErrorIntlKey = (textError: string) => BeErrorsMap[textError] || textError;
